import moment from 'moment';

export default function getReportTitle(tipnum, date = moment(), windowSize) {
  return `${tipnum.replace(/[^a-zA-Z0-9]/g, '')}_${windowSize}_${date.format('YYMMDD')}.pdf`;
}
